<template>
  <div>
    <NavigationBar
      titel="Veranstaltungsart anlegen"
      showBackBtn
      :actions="actions"
    ></NavigationBar>
    <section>
      <v-form
        @submit.prevent="createItem"
        ref="form"
        v-model="helpers.formIsValid"
      >
        <event-type-editor v-model="eventType" mode="new"></event-type-editor>
      </v-form>
    </section>
  </div>
</template>

<script>
import { SCHEDULING } from "@/store/modules.js";
import { CREATE_EVENT_TYPE } from "@/store/action-types.js";
import NavigationBar from "@/components/_systemwide/NavigationBar.vue";
import EventTypeEditor from "@/components/scheduling/EventTypeEditor.vue";

export default {
  name: "scheduling-config-tab-event-types-event-type-new",
  components: {
    NavigationBar,
    EventTypeEditor,
  },
  data() {
    return {
      actions: [
        {
          title: "Erstellen",
          icon: "mdi-plus-circle",
          actionStyle: "textBtnSubmit",
          function: this.createItem,
        },
      ],
      eventType: {
        title: "",
        shortTitle: "",
        description: "",
        color: "#F44336",
        sortKey: Number,
        dutyType: {
          title: "",
          id: "",
        },
        dutyReportReminder: {
          isActive: false,
          notifyPersons: [],
        },
      },
      helpers: {
        formIsValid: false,
      },
    };
  },
  computed: {
    newSortKey() {
      return this.$store.state.scheduling.eventTypes.length + 1;
    },
  },
  created() {
    this.initialize();
  },
  methods: {
    initialize() {
      this.eventType.sortKey = this.newSortKey;
    },
    validate() {
      this.$refs.form.validate();
    },
    createItem() {
      this.validate();
      if (this.helpers.formIsValid) {
        this.$store.dispatch(`${SCHEDULING}${CREATE_EVENT_TYPE}`, {
          organizationId: this.$route.params.organizationId,

          title: this.eventType.title,
          shortTitle: this.eventType.shortTitle,
          description: this.eventType.description,
          color: this.eventType.color,
          sortKey: this.eventType.sortKey,
          dutyType: {
            title: this.eventType.dutyType.title,
            id: this.eventType.dutyType.id,
          },
          dutyReportReminder: {
            isActive: this.eventType.dutyReportReminder.isActive,
            notifyPersons: this.eventType.dutyReportReminder.notifyPersons,
          },
        });
      } else {
        alert("Prüfe Deine Eingabe und versuche es erneut.");
      }
    },
  },
};
</script>

<style></style>
